<script>
import { mapState } from "vuex";
import TreeChart from "vue-tree-chart";

export default {
	name: "hirarki",
	components: { TreeChart },
	data() {
		return {
			info: {},
			currentPage: 1,
			totalPages: 0,
			loading: true,
		};
	},
	mounted() {
		this.findAll();
	},
	computed: {
		...mapState({
			treeData: (state) => state.service.hirarki,
		}),
		isLoading() {
			return this.$store.state.isLoading;
		},
	},
	methods: {
		findAll() {
			this.$store.dispatch("service/getHirarki");
		},
		refreshData() {
			this.findAll();
		},
		clickNode: function (node) {
			// eslint-disable-next-line
			console.log("ID", node.id);
			console.log("TYPE", node.type);
		},
	},
};
</script>

<template>
	<div>
		<Breadcrumbs title="Hirarki" />
		<!-- Container-fluid starts-->
		<div class="container-fluid">
			<div class="card">
				<div class="card-header">
					<div class="row">
						<div class="col-sm-6 create-project-btn"></div>
						<div class="col-sm-6 create-project-btn">
							<div class="text-right">
								<b-button-group class="btn-group-pill">
									<b-button
										variant="primary"
										size="sm"
										@click="refreshData()"
										v-b-tooltip.hover
										title="Refresh"
									>
										<div
											v-show="isLoading"
											class="spinner-border spinner-border-sm text-light"
											role="status"
											aria-hidden="true"
										></div>
										<i class="fa fa-refresh" v-show="!isLoading"></i
									></b-button>
								</b-button-group>
							</div>
						</div>
					</div>
				</div>

				<div class="card-body">
					<div class="treeview">
						<TreeChart
							:json="treeData"
							class=""
							@click-node="clickNode"
						/>
					</div>
				</div>
			</div>
		</div>

		<b-modal id="modal-info" hide-footer size="lg" title="Informasi Wilayah">
			<table class="table">
				<tbody>
					<tr>
						<td>Nama Wilayah</td>
						<td>:</td>
						<td>{{ this.info.nama }}</td>
					</tr>
					<tr>
						<td>Pelindung</td>
						<td>:</td>
						<td>{{ this.info.pelindung }}</td>
					</tr>
					<tr>
						<td>Nama Ketua</td>
						<td>:</td>
						<td>{{ this.info.ketua }}</td>
					</tr>
					<tr>
						<td>No. HP Ketua</td>
						<td>:</td>
						<td>{{ this.info.ketua_nohp }}</td>
					</tr>
					<tr>
						<td>Alamat Ketua</td>
						<td>:</td>
						<td>{{ this.info.ketua_alamat }}</td>
					</tr>
					<tr>
						<td>Nama Sekretaris</td>
						<td>:</td>
						<td>{{ this.info.sekretaris }}</td>
					</tr>
					<tr>
						<td>No. HP Sekretaris</td>
						<td>:</td>
						<td>{{ this.info.sekretaris_nohp }}</td>
					</tr>
					<tr>
						<td>Alamat Sekretaris</td>
						<td>:</td>
						<td>{{ this.info.sekretaris_alamat }}</td>
					</tr>
					<tr>
						<td>Nama Bendahara</td>
						<td>:</td>
						<td>{{ this.info.bendahara }}</td>
					</tr>
					<tr>
						<td>No. HP Bendahara</td>
						<td>:</td>
						<td>{{ this.info.bendahara_nohp }}</td>
					</tr>
					<tr>
						<td>Alamat Bendahara</td>
						<td>:</td>
						<td>{{ this.info.bendahara_alamat }}</td>
					</tr>
				</tbody>
			</table>
		</b-modal>
	</div>
</template>

<style lang="scss">
.treeview {
	overflow: auto;
}

.node .person .name {
	width: auto !important;
	word-wrap: break-word;
	height: auto;
}
.node .person .name[data-v-3e1326fa] {
	width: auto !important;
	word-wrap: break-word;
	height: auto;
}
</style>